import { convertArrayToFilterOptions } from 'utils/helpers/filters';

export const booleanSelectOptions = convertArrayToFilterOptions([true, false]);
